import { onlyDocumentChars } from 'shared/helpers/string';
import { LegacyEmissorJson } from './helpers/buildEmissorPayload';

export interface IErrors {
  file?: string;
  cnpj?: string;
  customer?: string;
}

export interface ValidateEmissorFormInput {
  parsedJson: LegacyEmissorJson | null;
  customerId?: number;
}

const validateEmissorForm = ({
  parsedJson,
  customerId,
}: ValidateEmissorFormInput): IErrors => {
  const errors: IErrors = {};

  if (!parsedJson) {
    errors.file = 'Selecione um arquivo JSON válido';
    return errors;
  }

  if (!customerId || !Number.isFinite(customerId)) {
    errors.customer = 'Cliente inválido para criar o emissor';
  }

  const cnpj = parsedJson.instalacoes?.[0]?.cnpj;
  if (!cnpj || !onlyDocumentChars(String(cnpj))) {
    errors.cnpj = 'CNPJ da instalação é obrigatório no JSON';
  }

  return errors;
};

export default validateEmissorForm;
